<template>
  <div class="flex flex-wrap items-center gap-2 text-xs">
    <span
      v-if="settings.group.column"
      class="rounded-md bg-gray-100 px-2 py-0.5 dark:bg-slate-700"
    >
      {{ $t('attributes.group_by') }} {{ labelOf(settings.group.column) }}
    </span>
    <span
      v-if="settings.sort.length"
      class="rounded-md bg-gray-100 px-2 py-0.5 dark:bg-slate-700"
    >
      {{ $t('global.sort_label') }} · {{ sortSummary }}
    </span>
    <span
      v-if="hidesDoneTasks"
      class="flex items-center gap-2 rounded-md bg-amber-50 px-2 py-0.5 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200"
    >
      {{ $t('global.done_tasks_hidden_by_status_filter') }}
      <button type="button" class="underline" @click="$emit('show-done')">
        {{ $t('global.show_done_tasks') }}
      </button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'TaskActiveSettingsChips',
  props: {
    settings: { type: Object, required: true },
    labelOf: { type: Function, required: true },
    hidesDoneTasks: { type: Boolean, required: false, default: false }
  },
  emits: ['show-done'],
  computed: {
    sortSummary() {
      return this.settings.sort
        .map(
          (level) =>
            `${this.labelOf(level.column)} ${level.direction === 'asc' ? '↑' : '↓'}`
        )
        .join(` ${this.$t('global.then_by')} `)
    }
  }
}
</script>
